import {
  EVENT_CONFIG_FETCH_REQUEST,
  EVENT_CONFIG_FETCH_SUCCESS,
  EVENT_CONFIG_FETCH_FAILURE,
  EVENT_CONFIG_UPDATE_REQUEST,
  EVENT_CONFIG_UPDATE_SUCCESS,
  EVENT_CONFIG_UPDATE_FAILURE,
  EVENT_CONFIG_TOGGLE_CHANNEL,
  EVENT_CONFIG_CLEAR_ERROR,
} from "./eventConfigTypes";

const initialState = {
  configs: [],
  isLoading: false,
  isUpdating: false,
  error: null,
};

const eventConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case EVENT_CONFIG_FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case EVENT_CONFIG_FETCH_SUCCESS:
      return {
        ...state,
        configs: action.payload,
        isLoading: false,
        error: null,
      };

    case EVENT_CONFIG_FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case EVENT_CONFIG_UPDATE_REQUEST:
      return {
        ...state,
        isUpdating: true,
        error: null,
      };

    case EVENT_CONFIG_UPDATE_SUCCESS:
      return {
        ...state,
        configs: state.configs.map((config) =>
          config.id === action.payload.id ? action.payload : config
        ),
        isUpdating: false,
        error: null,
      };

    case EVENT_CONFIG_UPDATE_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.payload,
      };

    case EVENT_CONFIG_TOGGLE_CHANNEL:
      return {
        ...state,
        configs: state.configs.map((config) => {
          if (config.id === action.payload.configId) {
            return {
              ...config,
              [action.payload.channel]: !config[action.payload.channel],
              lastEdited: new Date().toISOString().split("T")[0],
            };
          }
          return config;
        }),
      };

    case EVENT_CONFIG_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default eventConfigReducer;
